import {objToList, reduceToObj} from "../../../lib/utils";
import {ArticleTemplate, ArticleTemplateFromPHP, Column} from "../data";
import {hydrateTemplateWithRestrictedColumn} from "../read-only/data";

export type ArticleTemplateId = string

export const maxPrioritiesFromLayout = (layout: Layout) => {
	const articleTemplates = objToList((a: ArticleTemplate): ArticleTemplate => a, layout)
	return maxPrioritiesFromList(articleTemplates)
}

export const maxPrioritiesFromList = (articleTemplates: ArticleTemplate[]): {[k in Column]: number} => {
	const priorities = {
		'1': 0,
		'2': 0,
		'3': 0,
	}
	articleTemplates.forEach((a: ArticleTemplate) => {
		priorities[a.column] = priorities[a.column] + 1
	})
	return priorities
}

export type Layout = {[articleTemplateId:string]: ArticleTemplate}

export const layoutFromTemplates = (articleTemplates: ArticleTemplateFromPHP[], columns: Column): Layout => {
	const sortedArticleTemplates = articleTemplates.sort((a, b) => {
		return a.column === b.column ? a.priority - b.priority : a.column - b.column
	})
	const priorities = { '1': 1, '2': 1, '3': 1, }
	const hydrate = hydrateTemplateWithRestrictedColumn(columns)

	return reduceToObj<string, ArticleTemplateFromPHP, ArticleTemplate, Layout>(
		(a) => a.id.toString(),
		(a) => {
			const hydrated = hydrate(a)
			return {...hydrated, priority: priorities[hydrated.column]++}
		},
		sortedArticleTemplates
	)
}



// WEBPACK FOOTER //
// ./src/communications/article-templates/writable/data.ts